// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Wx62k","text-and-icon":"Button_text-and-icon__D9xe9","light":"Button_light__opChS","dark":"Button_dark__qwSZs"};